/**
 * Instruction Visuals Component
 * Displays instructional images/GIFs for each browser
 */

import React, { useState } from 'react'
import { Box, Card, CardMedia, Typography, Skeleton } from '@mui/material'

export const InstructionVisuals = ({ visuals = [] }) => {
  const [loadedImages, setLoadedImages] = useState({})
  const [errorImages, setErrorImages] = useState({})

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }))
  }

  const handleImageError = (index) => {
    setErrorImages((prev) => ({ ...prev, [index]: true }))
  }

  if (!visuals || visuals.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        my: 3,
      }}
    >
      {visuals.map((visual, index) => (
        <Card
          key={index}
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 2,
          }}
        >
          {!loadedImages[index] && !errorImages[index] && (
            <Skeleton variant="rectangular" height={300} animation="wave" />
          )}
          
          {errorImages[index] ? (
            <Box
              sx={{
                height: 300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Visual guide temporarily unavailable
              </Typography>
            </Box>
          ) : (
            <CardMedia
              component="img"
              image={visual.src}
              alt={visual.alt}
              onLoad={() => handleImageLoad(index)}
              onError={() => handleImageError(index)}
              sx={{
                width: '100%',
                height: 'auto',
                maxHeight: 400,
                objectFit: 'contain',
                backgroundColor: '#fafafa',
                display: loadedImages[index] ? 'block' : 'none',
              }}
            />
          )}
          
          {visual.caption && (
            <Box sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
              <Typography variant="body2" color="text.secondary" textAlign="center">
                {visual.caption}
              </Typography>
            </Box>
          )}
        </Card>
      ))}
    </Box>
  )
}

export default InstructionVisuals


















